/**
 * リダイレクト指令のエラー
 */
export class GraphQLRedirectError extends Error {
  constructor(
    readonly statusCode: number,
    readonly location: string,
    readonly message: string
  ) {
    super(message);
  }
}

/**
 * リソースが見つからないときのエラー
 */
export class GraphQLNotFoundError extends Error {
  constructor(readonly message: string) {
    super(message);
  }
}

/**
 * リソース絵のアクセス禁止エラー
 */
export class GraphQLForbiddenError extends Error {
  constructor(readonly message: string) {
    super(message);
  }
}

/**
 * 認証エラー
 */
export class GraphQLAuthenticationError extends Error {
  constructor(readonly message: string) {
    super(message);
  }
}

/**
 * InternalServerError
 */
export class GraphQLInternalError extends Error {
  constructor(readonly message: string, readonly alertMessage?: string | null) {
    super(message);
    this['alertMessage'] = alertMessage ?? undefined;
  }
}
